import React, { useEffect, useState } from 'react';
import './Sidebar.css';
import { RiHome5Line } from 'react-icons/ri';
import { AiOutlineFileSearch } from 'react-icons/ai';
import { IoSettingsOutline } from 'react-icons/io5';
import { MdOutlineNotificationsActive } from 'react-icons/md';
import { LuStickyNote } from 'react-icons/lu';
import { FiEdit } from 'react-icons/fi';
import { PiBookOpenText } from 'react-icons/pi';
import { VscTools } from 'react-icons/vsc';
import { Link, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Tooltip } from 'antd';
import { UserProfileActionHandler } from '../../Redux/Actions/user/SettingsUserProfile';
import { useDispatch } from 'react-redux';

const Sidebar = ({ isCollapsed, setIsCollapsed }) => {
    let dispatch = useDispatch();
    const rightArrow = '/assets/Arrow-right.svg';
    const leftArrow = '/assets/Arrow-left.svg';
    const QAlogo = '/assets/QALogo.svg';
    const logo = '/assets/logowhite.svg';
    const logoutlogo = '/assets/logoutlogo.svg';
    const whiteLogo = '/assets/logowhite-dev.svg';

    const [activeItem, setActiveItem] = useState('');

    const location = useLocation();
    const mainPath = location?.pathname.split('/')[1];

    let Navigate = useNavigate();

    const isSubscription = useSelector(
        (state) =>
            state.SettingsUserProfileData?.user_profile_data?.subscription
    );
    const userProfileData = useSelector(
        (state) => state.SettingsUserProfileData?.user_profile_data
    );
    const handleClick = (item, isSubscription) => {
        if (isSubscription) {
            if (item.isExternalLink) {
                window.open(item.path, '_blank');
                setActiveItem(activeItem.path);
            } else {
                setActiveItem(item.path);
            }
        }

        //gtm
        window.dataLayer.push({
            event: item?.label,
            buttonName: item?.label,
            userId: JSON.parse(localStorage.getItem('userDetails'))?.id,
            clientId: JSON.parse(localStorage.getItem('userDetails'))
                ?.client_id,
        });
        return;
    };
    useEffect(() => {
        dispatch(UserProfileActionHandler());
        const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    }, []);
    useEffect(() => {
        if (
            userProfileData?.is_mfa_enabled === false &&
            userProfileData?.client_mfa_enabled === true
        ) {
            Navigate('/');
        }
    }, [userProfileData]);
    useEffect(() => {
        mainPath ? setActiveItem(mainPath) : setActiveItem('');
        if (isSubscription != undefined && !isSubscription && activeItem) {
            if (mainPath !== 'settings') {
                Navigate('/settings');
            }
        }
    }, [mainPath, activeItem]);

    const handleToggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };

    const routes = [
        {
            sectionTitle: 'Main Menu',
            items: [
                {
                    icon: <RiHome5Line className='sideIcon-size home-size' />,
                    label: 'Home',
                    path: '',
                },
                {
                    icon: <LuStickyNote className='sideIcon-size' />,
                    label: 'Workspace',
                    path: 'workspaces',
                },
                {
                    icon: <FiEdit className='sideIcon-size' />,
                    label: 'Build',
                    path: 'build',
                },
                // {
                //   icon: <FiEdit className="sideIcon-size" />,
                //   label: "New Build",
                //   path: "new-build",
                // },
                {
                    icon: <PiBookOpenText className='sideIcon-size' />,
                    label: 'Chat',
                    path: 'play',
                },
                {
                    icon: <AiOutlineFileSearch className='sideIcon-size' />,
                    label: 'Get Started',
                    path: 'get_started',
                },
            ],
        },
        {
            sectionTitle: 'Other Menu',
            items: [
                {
                    icon: (
                        <MdOutlineNotificationsActive className='sideIcon-size' />
                    ),
                    label: 'Notifications',
                    path: 'notifications',
                },
                {
                    icon: <IoSettingsOutline className='sideIcon-size' />,
                    label: 'Settings',
                    path: 'settings',
                },
            ],
        },
    ];

    // const pathLocation = routes.flatMap((route) =>
    //   route?.items?.map((item) => item?.path)
    // );

    const logoutHandler = () => {
        try {
            localStorage.clear();
            Navigate('/login');
            window.location.reload();
        } catch (error) {
            console.error('Error clearing localStorage:', error);
        }

        //gtm
        window.dataLayer.push({
            event: 'Logout ',
            buttonName: 'Logout',
            userId: JSON.parse(localStorage.getItem('userDetails'))?.id,
            clientId: JSON.parse(localStorage.getItem('userDetails'))
                ?.client_id,
        });
    };

    return (
        <div className='sidebar-container'>
            <div
                className={
                    isCollapsed ? 'sidebar-header-collap' : 'sidebar-header'
                }>
                <img
                    src={isCollapsed ? QAlogo : whiteLogo}
                    alt=''
                    className={
                        isCollapsed ? 'sidebar-logo-collabsed' : 'sidebar-logo'
                    }
                />
            </div>
            <div className='separator'></div>

            <div className='side-cus'>
                {routes.map((section, index) => (
                    <div
                        key={index}
                        className={` ${
                            section?.sectionTitle === 'Other Menu'
                                ? isCollapsed
                                    ? 'other-menu-collpase'
                                    : 'other-menu'
                                : 'sidemenu-section sidebar-custom-scrollbar'
                        }`}>
                        <h2 className='section-title'>
                            {section.sectionTitle === 'Main Menu' ? (
                                <div
                                    className={
                                        isCollapsed
                                            ? 'arrow-event-collpased'
                                            : 'arrow-event'
                                    }>
                                    <img
                                        src={
                                            isCollapsed ? rightArrow : leftArrow
                                        }
                                        alt=''
                                        onClick={handleToggleSidebar}
                                    />
                                </div>
                            ) : (
                                ''
                            )}
                        </h2>
                        <div
                            className={
                                isCollapsed
                                    ? 'menu-item-collpased'
                                    : 'menu-items '
                            }>
                            {section.items.map((item, itemIndex) => (
                                <Tooltip
                                    title={
                                        !isSubscription &&
                                        item.path !== 'settings' &&
                                        'Please pick a plan to use the platform!'
                                    }
                                    placement='right'
                                    overlayStyle={{
                                        maxWidth: '900px',
                                        width: '310px',
                                    }}
                                    color={'#585858'}>
                                    <Link
                                        style={
                                            !isSubscription &&
                                            item?.path !== 'settings'
                                                ? {
                                                      opacity: '0.5',
                                                      background: '#5b5b5b',
                                                  }
                                                : {}
                                        }
                                        key={itemIndex}
                                        to={
                                            isSubscription
                                                ? `/${item.path}`
                                                : '/settings'
                                        }
                                        className={`${
                                            isCollapsed
                                                ? 'myStyledLink-sidebar-collpased'
                                                : 'myStyledLink-sidebar'
                                        } ${
                                            activeItem === item.path
                                                ? 'active'
                                                : ''
                                        }`}
                                        onClick={() =>
                                            handleClick(item, isSubscription)
                                        }>
                                        {item.icon}
                                        <div
                                            className={` ${
                                                activeItem === item.path
                                                    ? 'active'
                                                    : 'sidebar-link-route '
                                            }`}
                                            style={{ whiteSpace: 'nowrap' }}>
                                            {isCollapsed ? '' : item.label}
                                        </div>
                                    </Link>
                                </Tooltip>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            <div className='logout-container' onClick={logoutHandler}>
                <button
                    className={
                        isCollapsed
                            ? 'logout-button-collasped'
                            : 'logout-button'
                    }>
                    {' '}
                    <img src={logoutlogo} alt='' />
                    <div>{isCollapsed ? '' : 'Logout'}</div>
                </button>
            </div>
        </div>
    );
};

export default Sidebar;
